import { useState, useEffect, useContext } from "react";
import { Card, Table, Form} from "react-bootstrap";
import { UserSettingsContext } from "../contexts/UserSettingsContext";

import authenticatedFetch from "./fetch"

import FacilityParticipation from "./FacilityParticipation";
import { cardOutlineStyle } from "./TaskCardParts";


const FacilityParticipationStatusTable = ({providerId, providerName, canEdit}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
    const [showInactive, setShowInactive] = useState(false);

    const { tasksRefresh } = useContext(UserSettingsContext);

    useEffect(() => {
      reload();
    }, [providerId, tasksRefresh]);
  
    function reload() {
      authenticatedFetch({
        path: "provider/participationstatus/facility/" + providerId,
        successHandler: function(result) {
          setIsLoaded(true);
          setData(result);
        },
        errorHandler: function(error) {
          setIsLoaded(true);
          setError(error);
        }
      });
    }
  
    var participationList;
  
    if (error)
    {
      participationList = <tr><td colSpan="11">Something went wrong... please reload the page...</td></tr>;
    }
    else if (!isLoaded)
    {
      participationList = <tr><td colSpan="11">Loading...</td></tr>;
    }
    else
    {
      participationList = data.hubs && data.hubs.length > 0
        && data.hubs.map((participation, i) => {
        return (
          <FacilityParticipation key={participation.id} onSave={reload} showInactive={showInactive} facilityId={participation.id} providerId={providerId} providerName={providerName} facilityName={participation.name} portal={participation.portalUrl} phone={participation.phone} email={participation.email} hours={participation.hours} notes={participation.notes} facilityType={participation.facilityType} address1={participation.address1} address2={participation.address2} city={participation.city} state={participation.state} zip={participation.zip} county={participation.county} fax={participation.fax} effectiveDate={participation.effectiveDate} expires={participation.expires} privilegesType={participation.privilegesType} active={participation.isActive} primary={participation.isPrimary} progress={participation.isInProgress} pending={participation.isPending} pendingTimestamp={participation.pendingTimestamp} notApplicable={participation.isNotApplicable} canEdit={canEdit} />
        )
      }, this);
    }
    return (
      <Card style={cardOutlineStyle}>
        <Card.Header className="d-flex flex-wrap align-items-center justify-content-between gap-2" style={{paddingBottom: 8}}>
          <Card.Title as="h5" className="mb-0">Locations</Card.Title>
          <Form.Check
            type="switch"
            id="provider-locations-show-inactive"
            label="Show inactive and n/a"
            checked={showInactive}
            onChange={() => {setShowInactive(!showInactive)}}
            className="mb-0"
            style={{fontSize: "0.8rem"}}
          />
        </Card.Header>
        <Card.Body className="pt-0 pb-2">
        <Table striped hover size="sm" className="align-middle mb-0">
          <thead>
            <tr style={{fontSize: "0.7rem", letterSpacing: "0.06em", textTransform: "uppercase", color: "#8a929a"}}>
              <td>&nbsp;</td>
              <td>Name</td>
              <td>Contact</td>
              <td>Portal</td>
              <td>Active</td>
              <td>Primary</td>
              <td>Docs.</td>
              <td>Effective Date</td>
              <td>Next Renewal</td>
              <td>Privileges Type</td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody style={{borderTopWidth: 1, borderTopColor: "#DCE5E3"}}>
            {participationList}
          </tbody>
        </Table>
        </Card.Body>
      </Card>
    );
  };

export default FacilityParticipationStatusTable;